<template>
    <section class="assessmentSection questionsSection">
        <div class="questionsTopBG"></div>
        <div class="pageContent">
            <div class="pageTitle hasSubtitle onLight">We have some advice for protecting your home</div>
            <div class="pageSubtitle">
                <router-link to="/assessment/help/what-is-true-advice">What is this?</router-link>
            </div>

            <true-panel class="trueAdviceCard" v-for="(area, index) in system.advice.intrusion" :key="index">
                <div class="trueAdviceCard-header">
                    <img src="/img/window-opened.png"
                         alt="Open Window" /> Intrusion Protection
                </div>
                <div class="trueAdviceCard-advice">
                    Your {{ area.name }} windows are unprotected.
                </div>
                <div class="trueAdviceCard-detail">
                    This advice is generated based on the information you told us about your {{ area.name }}.
                </div>
                <div class="trueAdviceCard-learnAndResolve">
                    <router-link :to="`/assessment/true-advice/intrusion?id=${area.id}`">
                        Learn more and resolve
                    </router-link>
                </div>
            </true-panel>

            <true-panel class="trueAdviceCard" v-if="system.advice.environmental.length > 0">
                <div class="trueAdviceCard-header">
                    <img src="/img/alert.png"
                         alt="Open Window"> Fire Protection
                </div>
                <div class="trueAdviceCard-advice">
                    Consider adding {{ system.advice.environmental.length }} smoke communicators
                </div>
                <div class="trueAdviceCard-detail">
                    This advice is generated based on your homes size, number of floors, and information provided about your basement.
                </div>
                <div class="trueAdviceCard-learnAndResolve">
                    <router-link to="/assessment/true-advice/fire">
                        Learn more and resolve
                    </router-link>
                </div>
            </true-panel>

            <router-link to="/assessment/checkout" class="btn system-card-checkout">Continue without advice</router-link>

        </div>
    </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState(["system"])
  },
  methods: {
    ...mapActions(["updateSystem", "resolveAdvice"])
  },
  mounted() {
    this.updateSystem();
    mixpanel.track("openedTrueAdvice")
  }
};
</script>

<style lang="css">

</style>
